import { defineMessages } from 'react-intl';

export const messages: {
	buttonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	buttonLabel: {
		id: 'company-hub.common.manage-translations.button-label',
		defaultMessage: 'Manage translations',
		description: 'Button text used to open the translations view.',
	},
});
